import { Loading } from '@cibo/profile'
import { useProgram } from '@cibo/programs'
import { useParams } from 'react-router-dom'
import { ProgramV1Detail } from './ProgramV1Detail'
import { ProgramV2Detail } from './ProgramV2Detail'

export const ProgramDetailLayout = () => {
  const { programId } = useParams()

  const program = useProgram({ programId })

  if (!programId) {
    return null
  }

  if (!program.isFetched) {
    return <Loading />
  }

  switch (program.data?.rulesVersion) {
    case 'v1':
      return <ProgramV1Detail />

    case 'v2':
      return <ProgramV2Detail />

    default:
      return null
  }
}
